import {Box, Stack, useTheme} from '@mui/material';
import {HeaderTabNavigation, MainFooter} from 'presentation/components';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {Loading} from 'presentation/components/Loading/Loading';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {StyledContainer} from '../../styles';
import {MyHospitalizationFilterHeader} from '../Filter';
import {NoHospitalizationActive} from '../NoHospitalizationActive';
import {LayoutContainerProps} from './types';
import {usePatientData} from '../../pages/PatientData/hooks/usePatientData';

const {loading} = translations['pt-br'].commons;

export const LayoutContainer = ({children, filterConfig, tabs}: LayoutContainerProps) => {
	const theme = useTheme();
	const {isTablet, isMobile} = useMediaQueries();
	const {data, isError, isLoading} = usePatientData();

	if (isLoading) {
		return (
			<StyledContainer isMobile={isTablet}>
				<Loading text={loading} minHeight="100%" />
			</StyledContainer>
		);
	}

	if (!data || isError) {
		return (
			<StyledContainer isMobile={isTablet}>
				<NoHospitalizationActive />
			</StyledContainer>
		);
	}

	return (
		<Fragment>
			<Stack sx={{position: 'sticky', top: isMobile ? '96px' : '128px', zIndex: 1}}>
				{tabs ? (
					<HeaderTabNavigation
						variant={isMobile ? 'fullWidth' : 'scrollable'}
						tabs={tabs}
						customBackground={theme.colors.gray['10Percent']}
						customTabProps={{sx: {padding: '8px 16px'}}}
					/>
				) : null}
				{filterConfig ? <MyHospitalizationFilterHeader {...filterConfig} /> : null}
			</Stack>

			<StyledContainer isMobile={isTablet}>
				{children}

				<Box mt="auto">
					<MainFooter noMargin />
				</Box>
			</StyledContainer>
		</Fragment>
	);
};
